import qs from 'qs';
import React, {useState} from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {useHistory} from 'react-router';
import {Link} from 'react-router-dom';
import {hot} from 'react-hot-loader';
import {compose} from 'recompose';
import {
    Input,
    List,
    Icon,
    Popup,
    Dimmer,
    Divider,
    Label,
    Loader,
    Transition,
    Checkbox,
    Button
} from 'semantic-ui-react';

import {FixedSizeList} from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

import {withLocale} from 'op/components/locale';
import { withOnlineStatus } from 'op/components/offline';

import SearchFilter from './search-filter';
import {withPersonSeach, withSearchFiltering} from './person-search.helper';

const getRedinessColor = (person) => {
    if (person && person.readiness_level) {
        switch (person.readiness_level.id) {
            case 1:
                return 'green';
            case 2:
                return 'yellow';
            case 3:
                return 'red';
        }
    }
    return 'black';
}

const renderPersonCard =
    (person, style = {}, options = {}) => (
        <List.Item key={person.id} style={{...style, display: 'flex', alignItems: 'center'}}>
            {options.multiReportActive &&
            <Checkbox
                label=' '
                checked={!!options.selectedPeople[person.id]}
                onClick={() =>
                    options.setSelectedPeople({
                        ...options.selectedPeople,
                        [person.id]: !options.selectedPeople[person.id]
                    })
                }/>
            }
            <List.Icon name='user' size='large' verticalAlign='middle' color={getRedinessColor(person)}/>
            <List.Content>
                <List.Header>
                    <Link to={`/person/${person.id}`}>{person.display}</Link>
                </List.Header>
                {person.isAus?
                <List.Description>{person.id}/{person.unit.name}/{person.birthday ? moment(person.birthday).locale('en').format('DD.MM.YYYY') : ""}</List.Description>
                :<List.Description>{person.id}/{person.unit.name}/{person.job.name}/{person.birthday ? moment(person.birthday).locale('en').format('DD.MM.YYYY') : ""}</List.Description>
                 } </List.Content>
        </List.Item>
    );

const Search = styled(Input)`
	width: 100%;
	border: 0;
`;

const StyledPage = styled.div`
	min-height: calc(100vh - 150px);
`;

const StyledPartialLoaderContainer = styled.div`
	position: absolute;
	width: 100%;
`;

export const ActionBar = styled.div`
	display: inline;
  position: fixed;
  top: calc(100vh - 20px - 4em);
  ${props => props.direction || 'right'}: 20px;
  z-index: 3000;
  -webkit-backface-visibility: hidden;
`;


const renderFilter = ({unit, setUnit, job, setJob, readiness, setReadiness}) => {
    const [openModal, setOpenModal] = useState(false);
    return (
        <Popup
            on={'click'}
            open={openModal}
            hoverable
            onClose={() => setOpenModal(false)}
            position='bottom right'
            trigger={<Icon name='filter' inverted circular link onClick={() => setOpenModal(true)}/>}>
            <SearchFilter unit={unit} job={job} readiness={readiness} onUnitSelect={setUnit} onJobSelect={setJob}
                          onReadinessSelect={setReadiness} onClose={() => setOpenModal(false)}/>
        </Popup>
    );
};

const PersonSearch = ({loading, locale, people, search, setSearch, ...props, online}) => {
    const history = useHistory();
    const [selectedPeople, setSelectedPeople] = useState({});
    const [multiReportActive, setMultiReportActive] = useState(false);

    return (
        <StyledPage>
            <Search placeholder={locale.searchbar}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    icon={renderFilter(props)}
            />
            <Divider/>
            <StyledPartialLoaderContainer>
                <Transition.Group animation={'fly down'} duration={200}>
                    {loading == 'partial' && <Loader size='small' inline='centered'/>}
                </Transition.Group>
            </StyledPartialLoaderContainer>
            <Dimmer active={loading == 'full'}><Loader active/></Dimmer>
            <AutoSizer style={{marginTop: '20px'}}>
                {({height, width}) => (
                    <FixedSizeList
                        style={{direction: locale._meta.rtl ? 'rtl' : 'ltr'}}
                        width={width}
                        height={height}
                        itemCount={people.length || 0}
                        itemSize={44}
                    >
                        {({index, style}) => renderPersonCard(people[index], style, {
                            multiReportActive,
                            selectedPeople,
                            setSelectedPeople
                        })}
                    </FixedSizeList>
                )}
            </AutoSizer>
            <ActionBar direction={locale._meta.rtl ? 'left' : 'right'}>
                {multiReportActive &&
                <Button icon='close' circular size='small' secondary onClick={() => {
                    setMultiReportActive(false);
                    setSelectedPeople({});
                }}/>
                }
                <Button icon={multiReportActive ? `arrow ${locale._meta.rtl ? 'left' : 'right'}` : 'plus'} disabled={!online} circular
                        size='huge' primary onClick={() => {
                    if (!multiReportActive) {
                        setMultiReportActive(true);
                        return;
                    }

                    const selected = Object.entries(selectedPeople).filter(([, val]) => !!val).map(([key]) => key);

                    if (selected.length > 0) {
                        history.push({pathname: '/report/bulk', search: `?${qs.stringify({p: selected})}`})
                    }
                }}/>
            </ActionBar>
        </StyledPage>
    );
}

export default compose(
    withLocale('person.search'),
    withPersonSeach,
    withSearchFiltering,
    withOnlineStatus,
    hot(module),
)(PersonSearch);

